export default __webpack_public_path__ + "img/key.6c12d1c7.svg";